const translations = {
  english: {
    farmConnect: "KhetiSathi",
    tagline: "Seamlessly book farm workers and services to boost your harvest.",
    getStarted: "Book Now",
    ourServices: "Our Services",
    custom: "Custom",
    popular: "Popular",
    select: "Select",
    bookService: "Book a Service",
    serviceType: "Service Type",
    selectService: "Select Service",
    selectBundle: "Select Bundle",
    noBundle: "No Bundle (Custom)",
    maleWorkers: "Male Workers",
    femaleWorkers: "Female Workers",
    otherWorkers: "Number of Workers",
    hours: "Hours",
    numberOfDays: "Number of Days",
    startDate: "Start Date",
    endDate: "End Date",
    startTime: "Start Time",
    selectTime: "Select Time",
    locationDetails: "Location Details",
    fullAddress: "Full Address",
    contactNumber: "Contact Number",
    paymentDetails: "Payment Details",
    paymentMethod: "Payment Method",
    selectMethod: "Select Method",
    cash: "Cash",
    online: "Online",
    additionalNote: "Additional Note",
    reviewOrder: "Review Your Order",
    service: "Service",
    bundle: "Bundle",
    days: "Days",
    address: "Address",
    contact: "Contact",
    payment: "Payment",
    note: "Note",
    cost: "Cost",
    submitOrder: "Submit Order",
    serviceBooked: "Service Booked Successfully!",
    orderPlaced: "Your order has been placed. We'll confirm your booking soon.",
    backToHome: "Track Order",
    whatFarmersSay: "What Farmers Say",
    testimonial1: "Hired 5 workers in minutes!",
    testimonial2: "Tractor drivers were punctual.",
    testimonial3: "Best service for irrigation setup!",
    farmer1: "Raj Sharma, Corn Farmer",
    farmer2: "Shubham, Soybean Farmer",
    farmer3: "aman kumar, Rice Farmer",
    trustedPartner: "Your trusted partner for farm services.",
    contactUs: "Contact us",
    email: "support@khetisathi.com",
    phone: "+91-7020258039",
    day: "Day",
    daysPlural: "Days",
    vehicleType: "Vehicle Type",
    vehicleCost: "Vehicle Cost",
    workersCost: "Workers Cost",
    totalCost: "Total Cost",
    cashPaymentModalTitle: 'Cash Payment Information',
    cashPaymentModalMessage: 'For cash payments, the 10% service fee must be paid online via Razorpay. The remaining amount (workers’ cost and vehicle cost, if applicable) can be paid directly to the worker in cash.',
    serviceFee: 'Service Fee',
    payOnline: 'Pay Online',
    payOffline: 'Pay Offline (to worker)',
    understood: 'Understood',
    serviceFeePaid: 'Service Fee Paid',
    downloadApp: 'Download Our App',
    downloadAppDescription: 'Download our app and book services anytime, anywhere!',
    schedule: "Schedule",
    details: "Details",
    review: "Review",
    success: "Success",
    selectDistrict: "Select District",
    selectTahsil: "Select Tahsil",
    selectVillage: "Select Village",
    district: "District",
    tahsil: "Tahsil",
    village: "Village",
    newBundlesAvailable: "New Bundles Available",
    orderNow: "Order Now",
    maleWages: "Male Wages",
    femaleWages: "Female Wages",
    driverWages: "Driver Wages",
    timeRange: "Time Range",
    location: "Location",
    available: "Available",
    unavailable: "Unavailable",
    orderClosed: "Order Closed",
PerAcre: "Per Acre",
    PerHour: "Per Hour",
    PerDay: "Per Day",
    PerBag: "Per Bag",
    FixedPrice: "Fixed Price",
    acre: "acre",
    bag: "bag",
    fixedPrice: "Fixed Price",
    pleaseLoginOrRegister: 'Please Login or Register',
    loginOrRegisterMessage: 'Please login or register first to book service',
    login: 'Login',
    register: 'Register',
    pleaseSelectService: 'Please select a service.',
    selectBundleOrWorker: 'Please select a bundle or specify at least one worker.',
    specifyAtLeastOneWorker: 'Please specify at least 1 worker.',
    specifyAcres: 'Please specify the number of acres.',
    specifyAtLeastOneHour: 'Please specify at least 1 hour.',
    specifyAtLeastOneBag: 'Please specify at least 1 bag.',
    fillDateTimeFields: 'Please fill in all date and time fields.',
    startDateAfter: 'Start date must be on or after {date}.',
    fillAddressContactFields: 'Please fill in all address and contact number fields.',
    contactNumberTenDigits: 'Contact number must be exactly 10 digits.',
    selectPaymentMethod: 'Please select a payment method.',
    // availabilityStatus: "Status",
    // availabilityDate: "Available on"
  },
  hindi: {
    farmConnect: "KhetiSathi",
    tagline: "अपनी फसल बढ़ाने के लिए आसानी से खेत मजदूर और सेवाएं बुक करें।",
    getStarted: "बुक करें",
    ourServices: "हमारी सेवाएं",
    custom: "कस्टम",
    popular: "लोकप्रिय",
    select: "चुनें",
    bookService: "सेवा बुक करें",
    serviceType: "सेवा का प्रकार",
    selectService: "सेवा चुनें",
    selectBundle: "बंडल चुनें",
    noBundle: "कोई बंडल नहीं (कस्टम)",
    maleWorkers: "पुरुष मजदूर",
    femaleWorkers: "महिला मजूर",
    otherWorkers: "कामगारों की संख्या",
    hours: "घंटे",
    numberOfDays: "दिनों की संख्या",
    startDate: "प्रारंभ तिथि",
    endDate: "समाप्ति तिथि",
    startTime: "प्रारंभ समय",
    selectTime: "समय चुनें",
    locationDetails: "स्थान विवरण",
    fullAddress: "पूरा पता",
    contactNumber: "व्हाट्सएप संपर्क नंबर",
    paymentDetails: "भुगतान विवरण",
    paymentMethod: "भुगतान विधि",
    selectMethod: "विधि चुनें",
    cash: "नकद",
    online: "ऑनलाइन",
    additionalNote: "अतिरिक्त नोट",
    reviewOrder: "अपने ऑर्डर की समीक्षा करें",
    service: "सेवा",
    bundle: "बंडल",
    days: "दिन",
    address: "पता",
    contact: "संपर्क",
    payment: "भुगतान",
    note: "नोट",
    cost: "लागत",
    submitOrder: "ऑर्डर सबमिट करें",
    serviceBooked: "सेवा सफलतापूर्वक बुक की गई!",
    orderPlaced: "आपका ऑर्डर सबमिट हो गया है। हम जल्द ही आपकी बुकिंग की पुष्टि करेंगे।",
    backToHome: "ऑर्डरची स्थिति देखे",
    whatFarmersSay: "किसान क्या कहते हैं",
    testimonial1: "मिनटों में 5 मजदूरों को काम पर रखा!",
    testimonial2: "ट्रैक्टर ड्राइवर समय पर थे।",
    testimonial3: "सिंचाई सेटअप के लिए सबसे अच्छी सेवा!",
    farmer1: "राज शर्मा, मक्का किसान",
    farmer2: "शुभम, सोयाबीन किसान",
    farmer3: "अमन कुमार, धान किसान",
    trustedPartner: "खेत सेवाओं के लिए आपका भरोसेमंद साथी।",
    contactUs: "हमसे संपर्क करें",
    email: "support@khetisathi.com",
    phone: "+91-7020258039",
    day: "दिन",
    daysPlural: "दिन",
    vehicleType: "शेतमजूर वाहतुकीचा वाहन प्रकार",
    vehicleCost: "वाहन लागत",
    workersCost: "कामगार लागत",
    totalCost: "कूल लागत",
    cashPaymentModalTitle: 'नकद भुगतान की जानकारी',
    cashPaymentModalMessage: 'नकद भुगतान के लिए, 10% सेवा शुल्क ऑनलाइन रेजरपे के माध्यम से देना होगा। शेष राशि (श्रमिक लागत और वाहन लागत, यदि लागू हो) नकद में सीधे श्रमिक को दी जा सकती है।',
    serviceFee: 'सेवा शुल्क',
    payOnline: 'ऑनलाइन भुगतान करें',
    payOffline: 'ऑफलाइन भुगतान करें (श्रमिक को)',
    understood: 'समझ गया',
    serviceFeePaid: 'सेवा शुल्क भुगतान किया गया',
    downloadApp: 'हमारा ऐप डाउनलोड करें',
    downloadAppDescription: 'हमारा ऐप डाउनलोड करें और कभी भी, कहीं भी सेवाएँ बुक करें!',
    schedule: "समय निर्धारित करें",
    details: "विवरण",
    review: "समीक्षा",
    success: "सफलता",
    selectDistrict: "जिला चुनें",
    selectTahsil: "तहसील चुनें",
    selectVillage: "गाँव चुनें",
    district: "जिला",
    tahsil: "तहसील",
    village: "गाँव",
    orderNow: "अभी ऑर्डर करें",
    maleWages: "पुरुष मजदूरी",
    femaleWages: "महिला मजदूरी",
    driverWages: "ड्राइवर मजदूरी",
    timeRange: "समय सीमा",
    location: "स्थान",
    available: "उपलब्ध",
    unavailable: "अनुपलब्ध",
    orderClosed: "ऑर्डर बंद",
PerAcre: "प्रति एकड़",
    PerHour: "प्रति घंटा",
    PerDay: "प्रति दिन",
    PerBag: "प्रति बोरी",
    FixedPrice: "निश्चित मूल्य",
    acre: "एकड़",
    hour: "घंटा",
    bag: "बोरी",
    fixedPrice: "निश्चित मूल्य",
    pleaseLoginOrRegister: 'कृपया लॉगिन या रजिस्टर करें',
    loginOrRegisterMessage: 'सेवा बुक करने के लिए कृपया पहले लॉगिन या रजिस्टर करें',
    login: 'लॉगिन',
    register: 'रजिस्टर',
    pleaseSelectService: 'कृपया एक सेवा चुनें.',
    selectBundleOrWorker: 'कृपया एक बंडल चुनें या कम से कम एक कार्यकर्ता निर्दिष्ट करें.',
    specifyAtLeastOneWorker: 'कृपया कम से कम 1 कार्यकर्ता निर्दिष्ट करें.',
    specifyAcres: 'कृपया एकड़ की संख्या निर्दिष्ट करें.',
    specifyAtLeastOneHour: 'कृपया कम से कम 1 घंटा निर्दिष्ट करें.',
    specifyAtLeastOneBag: 'कृपया कम से कम 1 बोरी निर्दिष्ट करें.',
    fillDateTimeFields: 'कृपया सभी तारीख और समय के क्षेत्र भरें.',
    startDateAfter: 'प्रारंभ तिथि {date} या उसके बाद की होनी चाहिए.',
    fillAddressContactFields: 'कृपया सभी पता और संपर्क नंबर क्षेत्र भरें.',
    contactNumberTenDigits: 'संपर्क नंबर ठीक 10 अंकों का होना चाहिए.',
    selectPaymentMethod: 'कृपया भुगतान विधि चुनें.',
    //     availabilityStatus: "स्थिति",
    // availabilityDate: "उपलब्ध तिथि"
  },
  marathi: {
    farmConnect: "KhetiSathi",
    tagline: "तुमच्या पिकाला चालना देण्यासाठी सहजपणे शेतमजूर आणि सेवा बुक करा.",
    getStarted: "बुक करा",
    ourServices: "आमच्या सेवा",
    custom: "कस्टम",
    popular: "लोकप्रिय",
    select: "निवडा",
    bookService: "सेवा बुक करा",
    serviceType: "सेवा प्रकार",
    selectService: "सेवा निवडा",
    selectBundle: "बंडल निवडा",
    noBundle: "कोणताही बंडल नाही (कस्टम)",
    maleWorkers: "पुरुष मजूर (पेंडकर)",
    femaleWorkers: "महिला मजूर",
    otherWorkers: "कामगारांची संख्या",
    hours: "तास",
    numberOfDays: "दिवसांची संख्या",
    startDate: "काम सुरू करायची तारीख",
    endDate: "समाप्ती तारीख",
    startTime: "प्रारंभ वेळ",
    selectTime: "वेळ निवडा",
    locationDetails: "स्थान तपशील",
    fullAddress: "पूर्ण पत्ता",
    contactNumber: "व्हाट्सएप संपर्क क्रमांक",
    paymentDetails: "पेमेंट तपशील",
    paymentMethod: "पेमेंट पद्धत",
    selectMethod: "पद्धत निवडा",
    cash: "रोख",
    online: "ऑनलाइन",
    additionalNote: "अतिरिक्त टीप",
    reviewOrder: "तुमच्या ऑर्डरची पुनरावलोकन करा",
    service: "सेवा",
    bundle: "बंडल",
    days: "दिवस",
    address: "पत्ता",
    contact: "संपर्क",
    payment: "पेमेंट",
    note: "टीप",
    cost: "खर्च",
    submitOrder: "ऑर्डर सबमिट करा",
    serviceBooked: "सेवा यशस्वीरित्या बुक झाली!",
    orderPlaced: "तुमचा ऑर्डर सबमिट झाला आहे. आम्ही लवकरच तुमच्या बुकिंगची पुष्टी करू.",
    backToHome: "ऑर्डरची स्थिति पहा",
    whatFarmersSay: "शेतकरी काय म्हणतात",
    testimonial1: "काही मिनिटांत 5 मजूर भाड्याने घेतले!",
    testimonial2: "ट्रॅक्टर ड्रायव्हर एकदम योग्य वेळेवर आले होते.",
    testimonial3: "रोवणी शेतमजूरसाठी सर्वोत्तम सेवा!",
    farmer1: "राज शर्मा, मका शेतकरी",
    farmer2: "शुभम, सोयाबीन शेतकरी",
    farmer3: "अमन कुमार, धान शेतकरी",
    trustedPartner: "शेत सेवांसाठी तुमचा विश्वासू भागीदार.",
    contactUs: "आमच्याशी संपर्क साधा",
    email: "support@khetisathi.com",
    phone: "+91-7020258039",
    day: "दिवस",
    daysPlural: "दिवस",
    vehicleType: "शेतमजूर वाहतुकीचा वाहन प्रकार",
    vehicleCost: "वाहन खर्च",
    workersCost: "कामगार खर्च",
    totalCost: "एकूण खर्च",
    cashPaymentModalTitle: 'रोख पेमेंट माहिती',
    cashPaymentModalMessage: 'रोख पेमेंटसाठी, 10% सेवा शुल्क ऑनलाइन रेजरपे मार्फत द्यावे लागेल. उर्वरित रक्कम (कामगार खर्च आणि वाहन खर्च, लागू असल्यास) थेट कामगाराला रोखीने दिली जाऊ शकते.',
    serviceFee: 'सेवा शुल्क',
    payOnline: 'ऑनलाइन पेमेंट',
    payOffline: 'ऑफलाइन पेमेंट (कामगाराला)',
    understood: 'समजले',
    serviceFeePaid: 'सेवा शुल्क भरले',
    downloadApp: 'ऐप डाउनलोड करा',
    downloadAppDescription: 'आमचे ऐप डाउनलोड करा आणि कधीही, कुठेही सेवा बुक करा!',
    schedule: "वेळ ठरवा",
    details: "तपशील",
    review: "पुनरावलोकन",
    success: "यशस्वी",
    selectDistrict: "जिल्हा निवडा",
    selectTahsil: "तहसील निवडा",
    selectVillage: "गाव निवडा",
    district: "जिल्हा",
    tahsil: "तहसील",
    village: "गाव",
    newBundlesAvailable: "नवीन बंडल उपलब्ध",
    orderNow: "आता ऑर्डर करा",
    maleWages: "पुरुष मजूरी ",
    femaleWages: "महिला मजूरी",
    driverWages: "गाडी भाडा",
    timeRange: "वेळ",
    location: "रोवणी शेतमजुरांचे गांव ",
    //     availabilityStatus: "स्थिती",
    // availabilityDate: "उपलब्ध तारीख"
    available: "उपलब्ध",
    unavailable: "अनुपलब्ध",
    orderClosed: "ऑर्डर बंद",
    PerAcre: "एकूण एकर",
    PerHour: "प्रति तास",
    PerDay: "प्रति दिवस",
    PerBag: "प्रति पोती",
    FixedPrice: "निश्चित किंमत",
    acre: "एकर",
    hour: "तास",
    bag: "पोती",
    perDay: "प्रति दिवस",
    fixedPrice: "निश्चित किंमत",
    perAcre: "एकर",
    errorLoadingWorkers: 'कामगार लोड करण्यात त्रुटी',
    workerAvailability: 'लाखोरी मध्ये उपलब्ध कामगार',
    noWorkersAvailable: 'लाखोरी मध्ये कोणतेही कामगार उपलब्ध नाहीत',
    totalWorkers: 'एकूण उपलब्ध कामगार',
    pleaseLoginOrRegister: 'कृपया लॉगीन किंवा नोंदणी करा',
    loginOrRegisterMessage: 'सेवा बुक करण्यासाठी कृपया आधीच नोंदणी झाली असेल तर लॉगीन करा किंवा नोंदणी केली नसेल तर नोंदणी करा',
    login: 'लॉगीन',
    register: 'नोंदणी',
    pleaseSelectService: 'कृपया एक सेवा निवडा.',
    selectBundleOrWorker: 'कृपया एक बंडल निवडा किंवा किमान एक कामगार नमूद करा.',
    specifyAtLeastOneWorker: 'कृपया किमान १ कामगार नमूद करा.',
    specifyAcres: 'कृपया एकरांची संख्या नमूद करा.',
    specifyAtLeastOneHour: 'कृपया किमान १ तास नमूद करा.',
    specifyAtLeastOneBag: 'कृपया किमान १ पोते नमूद करा.',
    fillDateTimeFields: 'कृपया सर्व तारीख आणि वेळेची फील्ड्स भरा.',
    startDateAfter: 'प्रारंभ तारीख {date} किंवा त्यानंतरची असावी.',
    fillAddressContactFields: 'कृपया सर्व पत्ता आणि संपर्क क्रमांक फील्ड्स भरा.',
    contactNumberTenDigits: 'संपर्क क्रमांक नेमका १० अंकी असावा.',
    selectPaymentMethod: 'कृपया पेमेंट पद्धत निवडा.',
  },
};

export default translations;